import { pick } from 'lodash';
import type { PostTestInstanceResponse } from './types';

export const prepareTestInstanceResponse = (
  testInstanceResponse: Partial<PostTestInstanceResponse>
): MutationBody => ({
  data: {
    type: 'TestInstanceResponse',
    attributes: {
      ...pick(testInstanceResponse, ['status', 'session'])
    },
    relationships: {
      ...(testInstanceResponse.testInstance
        ? {
            testInstance: {
              data: {
                id: `/api/v2/test-instances/${testInstanceResponse.testInstance}`,
                type: 'TestInstance'
              }
            }
          }
        : {}),
      ...(testInstanceResponse.token
        ? {
            token: {
              data: { id: `/api/v2/tokens/${testInstanceResponse.token}`, type: 'Token' }
            }
          }
        : {}),
      ...(testInstanceResponse.user
        ? {
            user: {
              data: {
                id: `/api/v2/users-test-instances/${testInstanceResponse.user}`,
                type: 'UsersTestInstances'
              }
            }
          }
        : {})
    }
  }
});
